export function Letter() {
  return (
    <path
      fill="currentColor"
      d="M43.646 37.71H4.354c-.586 0-1.081-.498-1.081-1.087V17.859l20.009 9.813c.227.11.472.167.718.167.245 0 .49-.056.718-.167l20.01-9.814v18.765c0 .589-.496 1.087-1.082 1.087M4.354 10.29h39.292c.586 0 1.081.498 1.081 1.087v2.821L24 24.363 3.273 14.198v-2.82c0-.59.495-1.088 1.08-1.088M43.647 7H4.354C1.953 7 0 8.964 0 11.377v25.246C0 39.037 1.953 41 4.354 41h39.292C46.047 41 48 39.037 48 36.623V11.377C48 8.963 46.047 7 43.646 7"
    />
  )
}
